<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          Views Per Month
        </b-card-title>
      </div>
      <!--/ title and subtitle -->

    </b-card-header>

    <b-card-body>
    <b-row>
        <b-col md="2">
            <b-form-group>
            Year
            <v-select
              class="mt-1"
              v-model="selected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="option"
              :clearable="false"
              style="border-color:red;color:red;border: 0.01px solid #DD0000;border-radius: 0.357rem;"
            />
            </b-form-group>
        </b-col>
    </b-row>
      <b-spinner v-if="loading" class="align-middle mr-1 my-2" variant="secondary"></b-spinner>
      <vue-apex-charts
        type="bar"
        height="400"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BSpinner, BRow, BCol, BFormGroup, BButton, BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BBadge,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import moment from '@/libs/moment'
import vSelect from 'vue-select'

export default {
  components: {
    BSpinner,
    BRow, 
    BCol, 
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BFormGroup, 
    BButton, 
    vSelect,
    flatPickr
  },
  data() {
    return {
      loading: true,
      selected: new Date().getFullYear().toString(),
      option: ['2019', '2020', '2021', '2022', '2023'],
      from : moment().startOf('year').format('YYYY-MM-DD'),
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Views'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " views"
            }
          }
        }
      },
    }
  },

  mounted() {
    this.fetchYear()

    setTimeout(() => {
      this.fetchVisitors()
    }, 7000);
    this.option = this.option.sort().reverse();
  },

  watch: {
    selected(){
      this.fetchVisitors()
    }
  },
  methods: {
    fetchYear() {
      this.$http
        .get('/visitor-log/fetchYear')
        .then(({ data }) => {
          this.option = data.sort().reverse();
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => (this.loading = false))
    },
    fetchVisitors() {
      this.loading = true
      this.$http
        .get('/visitor-log/thisYear', {
          params: {
            year: this.selected
          },
        })
        .then(({ data }) => {
          const newData = data.map(item =>{
            return item.count
          });
          const newAxis = data.map(item =>{
            return item.month
          });

          this.chartOptions = {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: newAxis,
            },
            yaxis: {
              title: {
                text: 'Views'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + " views"
                }
              }
            }
          }
          this.series = [{
            data: newData
          }]
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => (this.loading = false))
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>